/**
 * 안전하게 decodeURIComponent를 수행하는 함수
 * @param str
 */
export const safeDecodeURIComponent = (str: string): string => {
  try {
    return decodeURIComponent(str);
  } catch (error) {
    return str; // 디코딩 실패 시 원본 값 반환
  }
};
